import { type TableColumnSpec } from "#blocks/Table/buildTableColumns"
import { CurriculumForTable } from "#customTypes/composedTypes/curriculumTypes"
import { toSortableNumber } from "#utils/sortHelpers"

export const CURRICULUM_TABLE_COLUMNS: TableColumnSpec[] = [
  { key: "name", width: 200 },
  { key: "semester", width: 120 },
  { key: "group", width: 130 },
  { key: "numberOfSessions", width: 130, align: "right", title: "Sessions" },
  { key: "skillLevels", width: 200 },
  { key: "cycle", width: 70, align: "right" },
  { key: "notes", width: 200 },
  { key: "lastUpdatedAt", width: 140, title: "Last Updated" },
]

export const CURRICULUM_SEARCHABLE_FIELDS: (keyof CurriculumForTable)[] = [
  "name",
  "group",
  "skillLevels",
] as const

export const CURRICULUM_SORTABLE_FIELDS = [
  "name",
  "semester",
  "group",
  "skillLevels",
  "cycle",
  "lastUpdatedAt",
] as const

// cycle is stored as a string number (1, 2, 3, ...); sort it numerically.
// Shared by useTableSort + buildTableColumns.
export const getCurriculumSortValue = (
  row: CurriculumForTable,
  field: string
): string | number => {
  if (field === "cycle") return toSortableNumber(row.cycle)
  const value = row[field]
  return typeof value === "number" ? value : String(value ?? "")
}
